import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "/api";

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.data?.error === "Invalid token") {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      // Force reload to reset React state
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (credentials) => api.post("/auth/login", credentials),
};

export const whitelistAPI = {
  getAll: () => api.get("/whitelist"),
  add: (ipData) => api.post("/whitelist", ipData),
  remove: (id) => api.delete(`/whitelist/${id}`),
  sync: () => api.post("/whitelist/sync"),
};

export default api;